<template>
  <div class="page-wrapper">
    <div class="error-page">
      <!-- Main Wrapper -->
      <div class="main-wrapper">
        <div class="error-box">
          <h1>404</h1>
          <h3><i class="fa fa-warning"></i> NOT FOUND!</h3>
          <p class="mt-4">Trang này không tồn tại.</p>
          <router-link to="/" class="btn btn-custom">Về trang chủ</router-link>
        </div>
      </div>
      <!-- /Main Wrapper -->
    </div>
  </div>
</template>
<style scoped>
.error-page {
  height: calc(100vh - 60px);
  background: linear-gradient(
    to right,
    rgb(231, 255, 209) 0%,
    #fff0e6,
    #d0ffff 100%
  );
}
</style>
